import React from "react";
import PropTypes from "prop-types";

class EmailTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            localUsers: [],
            sortFilter: {
                fieldName: "",
                logic: ""
            }
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.users !== this.props.users) {
            this.setState({
                localUsers: [...this.props.users]
            });
        }
    }

    sortUsers() {
        let { localUsers } = this.state;
        const {
            logic,
            fieldName
        } = this.state.sortFilter;

        if (logic === "asc") {
            localUsers = localUsers.sort((a, b) => {
                if (typeof a[fieldName] === "string") {
                    return ("" + a[fieldName]).localeCompare(b[fieldName]);
                } else {
                    return a[fieldName] - b[fieldName];
                }
            });
        } else if (logic === "desc") {
            localUsers = localUsers.sort((a, b) => {
                if (typeof a[fieldName] === "string") {
                    return ("" + b[fieldName]).localeCompare(a[fieldName]);
                } else {
                    return b[fieldName] - a[fieldName];
                }
            });
        } else {
            localUsers = this.props.users;
        }

        this.setState({
            localUsers: [...localUsers]
        });
    }

    sortData(column) {
        const { sortFilter } = this.state;

        if (sortFilter.fieldName === column) {
            if (sortFilter.logic === "asc") {
                sortFilter.logic = "desc";
                this.setState({
                    sortFilter: { ...sortFilter }
                }, () => this.sortUsers());
            } else if (sortFilter.logic === "desc") {
                sortFilter.logic = "";
                this.setState({
                    sortFilter: { ...sortFilter }
                }, () => this.sortUsers());
            } else {
                sortFilter.logic = "asc";
                this.setState({
                    sortFilter: { ...sortFilter }
                }, () => this.sortUsers());
            }
        } else {
            sortFilter.logic = "asc";
            sortFilter.fieldName = column;

            this.setState({
                sortFilter: { ...sortFilter }
            }, () => this.sortUsers());
        }
    };

    render() {
        const {
            users,
            selectedUsers,
            onSelectUserEmails,
            height
        } = this.props;

        if (!users.length) {
            return (
                <div className="text-center">
                    Email list is empty
                </div>
            );
        }

        return (
            <div
                className="mt-3"
                style={{
                    height: "100%",
                    maxHeight: height,
                    overflowY: "auto"
                }}
            >
                <table className="table table-sm table-condensed table-bordered table-hover">

                    <thead>
                    <tr>
                        <th>
                            <input
                                type="checkbox"
                                checked={
                                    selectedUsers.length &&
                                    selectedUsers.length === users.length
                                }
                                onChange={() => onSelectUserEmails(false)}
                            />
                        </th>
                        <th className="g-pointer" onClick={() => this.sortData("name")}>Name
                            <i className="fa fa-fw fa-sort"/>
                        </th>
                        <th className="g-pointer" onClick={() => this.sortData("email")}>Email
                            <i className="fa fa-fw fa-sort"/>
                        </th>
                    </tr>
                    </thead>

                    <tbody>
                    {this.state.localUsers.map(value => (
                        <tr
                            key={value.id}
                            className={`g-pointer ${selectedUsers.indexOf(value.email) > -1 ? "bg-success text-light" : ""}`}
                            onClick={() => onSelectUserEmails(value.email)}
                        >
                            <td>
                                <input
                                    type="checkbox"
                                    checked={selectedUsers.indexOf(value.email) > -1}
                                    readOnly={true}
                                />
                            </td>
                            <td>
                                {value.name}
                            </td>
                            <td>
                                {value.email}
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        );
    }
}

EmailTable.defaultProps = {
    height: 378
};

EmailTable.propTypes = {
    users: PropTypes.array.isRequired,
    selectedUsers: PropTypes.array.isRequired,
    onSelectUserEmails: PropTypes.func.isRequired,
    height: PropTypes.number
};

export default EmailTable;
